var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "home" } },
    [
      _c(
        "el-row",
        [
          _c("div", { staticClass: "bg", style: _vm.MAIN.BACK_GROUND }, [
            _c("div", { staticClass: "video-home" }, [
              !_vm.playInVideo
                ? _c("div", { staticClass: "texto-home" }, [
                    _c("h1", {
                      domProps: { innerHTML: _vm._s(_vm.MAIN.TITULO) }
                    }),
                    _vm.MAIN.EXIBIR_IMPORTANTE
                      ? _c(
                          "div",
                          { staticClass: "aviso", on: { click: _vm.redirect } },
                          [
                            _c("b", [_vm._v("IMPORTANTE!")]),
                            _c(
                              "p",
                              [
                                _vm._v(
                                  "Antes de iniciar o cadastro ou adquirir alguma ocupação de terras públicas estaduais leia essas informações.  "
                                ),
                                _c("font-awesome-icon", {
                                  staticClass: "icon",
                                  attrs: { icon: "arrow-right" }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]),
          _c("the-sicarf", { attrs: { id: "sicarf" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5892408c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5892408c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/Home.vue
// module id = null
// module chunks = 